import VehicleDetailsIconList from './VehicleDetailsIconList';

export default VehicleDetailsIconList;
